import { defineNuxtPlugin } from '#app'
import {
  nextTick, useNuxtApp, useRouter
} from '#imports'

export default defineNuxtPlugin({
  parallel: true,
  setup () {
    const router = useRouter()
    const { bus } = useNuxtApp()

    router.afterEach(async () => {
      await nextTick()
      bus.emit('scroll:start')
      bus.emit('scroll:refresh')
    })
  }
})
